import src from "IMAGE";
export default { src, width: 221, height: 56, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFkiLYI9ExxfBAcOFAMGDhIPBw4WHgcLFxsGChQgBwwZALg1T958IDWiChImNQkVLDgkFStBRxEcOUIQGi9OEh4/RUsKiEEYf3wAAAAASUVORK5CYII="};
